<template>
  <div ref="echart">
    <paint
      v-for="item in list"
      :title="item.url"
      :times="item.startTime"
      :key="item._id"
    />
  </div>
</template>

<script>
import request from '@/utils/request.js'
import paint from '@/components/paint.vue'

export default {
  props: {
    siteId: {
      type: Number
    },
    hosts: {
      type: Array
    }
  },
  data () {
    return {
      list: []
    }
  },
  components: {
    paint
  },
  watch: {
    siteId () {
      this.search()
    }
  },
  methods: {
    search () {
      request
        .get(`/performance/paint`, {
          params: {
            siteId: this.siteId,
            hosts: this.hosts
          }
        })
        .then((res) => {
          this.list = res.data
        })
    }
  },
  mounted () {
    this.search()
  }
}
</script>
